import * as types from '../actions/types';

const initialState = {
    searchtrainingdata:[],
    success:false
}

export default function TrainingSearchReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.SEARCH_TRAINING:
            return {
               
                searchtrainingdata:action.payload,
                success:true
            } 
        default:
            return state
    }
}
